export { default as TrustedShopReviews } from './TrustedShopReviews';
